<template>
  <div class="js-basedata-faultcode app-container">
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-filter="showfilter=true"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
      @click-search="listLoad"
      @click-import="importVisible=true"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      @row-click="rowClick"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
      >
        <template slot-scope="scope">
          <div v-if="item.prop==='bannerImg'">
            <img  :src="scope.row[item.prop]" width="50" height="50"/>
          </div>
          <div v-else-if="item.prop==='linkPath'">
            <a v-if="scope.row[item.prop]" :href="scope.row[item.prop]" style="color:#409eff" target="_blank">{{scope.row[item.prop]}}</a>
          </div>
          <div v-else>
            <span>{{ scope.row[item.prop] || '/' }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 新增编辑dialog弹窗 -->
    <add-update-dialog
      :visibles.sync="addUpdateVisible"
      :is-edit="isEdit"
      :data="isEdit?tableRow:{}"
      @add-complete="addComplete"
      @update-complete="updateComplete"
    />
    <!-- 查看dialog弹窗 -->
    <detail-dialog
      :visibles.sync="detailVisible"
      :data="tableRow"
    />
  </div>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// 组件
import AddUpdateDialog from './components/addUpdateDialog'
import detailDialog from './components/detailDialog'
// request
import { getBannerList,deleteBanner } from '@/api/userCenter/banner'
export default {
  name: 'Banner',
  components: { AddUpdateDialog, detailDialog },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle, getPageButton],
  data() {
    return {
      listQuery: {
      },
      brandList: [],
      showfilter: false,
      tableList: [
        { value: this.$t('banner.imgPath'), prop: 'bannerImg', sortable: 'custom', position: 'center', width: '90px', checked: true },
        { value: this.$t('banner.linkPath'), prop: 'linkPath', position: 'center', width: '120px', checked: true },
        { value: this.$t('public.description'), prop: 'bannerDescribe', sortable: 'custom', position: 'center', width: '140px', checked: true },
        { value: this.$t('public.createTime'), prop: 'createdOn', sortable: 'custom', position: 'center', width: '100px', checked: true },
      ],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      addUpdateVisible: false,
      importVisible: false,
      resultVisible: false,
      importResult: {},
      isEdit: false,
      tableRow: {},
      detailVisible: false
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  mounted() {
  },
  methods: {
    cellStyle(row) {
      if (row.column.label === this.tableList[1].value) {
        return { cursor: "pointer" }
      }
    },
    // 导入成功之后刷新list
    reloadList(data) {
      this.importResult = data
      if (data.failedList.length === 0 || !data.failedList) {
        this.resultVisible = false
        this.importVisible = false
      } else {
        this.resultVisible = true
      }
      // this.resultVisible = true
      this.listLoad()
    },
    // 加载数据
    listLoad() {
      this.listLoading = true
      getBannerList(this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.tableRow = {}
          this.list = data.data || []
          this.total = data.total
        }
        this.listLoading = false
      }).catch(()=>{
         this.listLoading = false
      })
    },
    // 点击列
    rowClick(row, column) {
      this.tableRow = {}
      this.list.some((item, index) => {
        if (item.shopId === row.shopId) {
          row.$index = index
        }
      })
      this.tableRow = row
      const label = column.label
      if (label === this.$t("shop.shopname")) {
        if(row.shopLink){
          window.open(row.shopLink)
        }
        
      }
    },
    // 判断是否选中
    tableRowIsSlect() {
      const { $index } = this.tableRow
      if ($index === undefined) {
        return false
      } else {
        return true
      }
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.addUpdateVisible = true
    },
    // 新增成功
    addComplete() {
      this.listLoad()
    },
    // 编辑
    handleUpdate() {
      if (this.tableRowIsSlect()) {
        this.isEdit = true
        this.addUpdateVisible = true
      } else {
        this.$alert(this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
          .then(() => {})
          .catch(() => {})
      }
    },
    // 编辑成功
    updateComplete() {
      this.listLoad()
    },
    // 删除
    handleDelete() {
      if (!this.tableRowIsSlect()) {
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      const deleteData = {
        id: this.tableRow.bannerId
      }
      this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
        .then(() => {
          deleteBanner(deleteData).then(({ data }) => {
            if (data.code === 0) {
              if (this.list && this.list.length === 1) {
                this.listQuery.pageNum =
                  this.listQuery.pageNum > 1
                    ? this.listQuery.pageNum - 1
                    : this.listQuery.pageNum
                this.listLoad()
              } else {
                this.list.splice(this.tableRow.$index, 1)
                this.tableRow = {}
              }
              this.total--
              this.$message.success({
                message: this.$t('public.deleteSuccess'),
                duration: 2 * 1000
              })
            }
          })
        })
        .catch(() => {})
    },
    // 详情
    handleAudit(row) {
      this.tableRow = row
      this.detailVisible = true
    }
  }
}
</script>

<style lang='scss' scoped>

</style>
